// @core/api/endpoints/knowledge/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateKnowledgeBase } from './create_knowledge_base';
import { DeleteKnowledgeBase } from './delete_knowledge_base';
import { GetKnowledgeBase } from './get_knowledge_base';
import { IndexSource } from './index_source';
import { ListKnowledgeBases } from './list_knowledge_bases';
import { ListSources } from './list_sources';
import { RemoveSource } from './remove_source';
import { Retrieve } from './retrieve';
import { UpdateKnowledgeBase } from './update_knowledge_base';

// Re-export individual endpoints
export {
  CreateKnowledgeBase,
  DeleteKnowledgeBase,
  GetKnowledgeBase,
  IndexSource,
  ListKnowledgeBases,
  ListSources,
  RemoveSource,
  Retrieve,
  UpdateKnowledgeBase,
};

// Namespace export for convenient usage
export const knowledgeApi = {
  CreateKnowledgeBase,
  DeleteKnowledgeBase,
  GetKnowledgeBase,
  IndexSource,
  ListKnowledgeBases,
  ListSources,
  RemoveSource,
  Retrieve,
  UpdateKnowledgeBase,
};
